export const findStringInEntity = (entity, str) => {
  if (!entity) return false;

  const trimmedString = str.toLowerCase().trim();
  const entityName = entity.title.toLowerCase().trim();

  if (entityName.indexOf(trimmedString) !== -1) {
    return true;
  }
};

export const filterByString = (entities, search) => {
  if (!search) return entities;
  return entities.filter(e => findStringInEntity(e, search));
};

export const filterByTags = (entities, tags) => {
  if (!tags || tags.length === 0) return entities;
  return entities.filter(
    entity =>
      entity.tags &&
      tags.every(tag => entity.tags.some(et => et.label === tag.label))
  );
};

export const getFilteredEntities = (
  entities,
  search,
  tags,
  personId,
  entityId
) => {
  const entitiesWithTags = filterByTags(entities, tags);
  let filteredEntities = filterByString(entitiesWithTags, search);
  if (entityId)
    filteredEntities = filteredEntities.filter(e => e.entity?.id === entityId);
  if (personId)
    filteredEntities = filteredEntities.filter(e => e.person?.id === personId);

  return filteredEntities;
};

export const highlightSearchedText = (label, value, attr = {}) => {
  if (!value) {
    return <span {...attr}>{label}</span>;
  }

  const regex = new RegExp(value.trim(), 'gi');

  const result = label.replace(
    regex,
    str => `<mark class="c-list__item-text--higlight">${str}</mark>`
  );
  return <span {...attr} dangerouslySetInnerHTML={{ __html: result }}></span>;
};
